var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminPromptsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 8.89474V13H0V0H6.25467C6.37844 6.78385e-05 6.49975 0.035499 6.60502 0.102325C6.71028 0.169152 6.79534 0.264734 6.85067 0.378368L7.33333 1.36842H11.3333C11.5101 1.36842 11.6797 1.44051 11.8047 1.56882C11.9298 1.69714 12 1.87117 12 2.05263V9.57895C12 9.76041 11.9298 9.93444 11.8047 10.0628C11.6797 10.1911 11.5101 10.2632 11.3333 10.2632H7.07867C6.95489 10.2631 6.83358 10.2277 6.72832 10.1608C6.62305 10.094 6.53799 9.99842 6.48267 9.88479L6 8.89474H1.33333ZM1.33333 1.36842V7.52632H6.824L7.49067 8.89474H10.6667V2.73684H6.50933L5.84267 1.36842H1.33333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPromptsIcon);
export default __webpack_public_path__ + "static/media/AdminPromptsIcon.113d29513c3866896de287dfca500cfb.svg";
export { ForwardRef as ReactComponent };